import {useTableConfig} from "../../../utils/hooks";
import i18next from "../../../services/language/i18next";
import {MANAGE_CHECK_ACTIONS} from "../../../utils/constants";
import {showNotification} from "../../../utils/actionWrappers";
import {numberToTimeDuration} from "../../../utils/timeHandlers";
import {deleteCheckRequest, getChecksRequest, manageCheckRequest} from "../../../services/api";

const useChecksData = () => {
  const tableConfig = useTableConfig(getChecksRequest);
  const {setProjectId, setTableItems} = tableConfig;

  const onSelectedProjectChange = (event) => setProjectId(event.target.value);

  const updateCheck = (id, checkData) => setTableItems((oldChecks) => {
    return oldChecks.map((check) => check.id === id ? checkData : check);
  });

  const returnCheck = (id) => {
    manageCheckRequest(id, MANAGE_CHECK_ACTIONS.RESUME)
      .then(({data}) => updateCheck(id, data))
      .then(() => showNotification(
        i18next.t("notification:title.success", "Success!"),
        i18next.t("notification:message.returned.check", "Check has been returned."),
        "success"
      ));
  };

  const pauseCheck = (id, time) => {
    manageCheckRequest(id, MANAGE_CHECK_ACTIONS.PAUSE, {duration: numberToTimeDuration(time)})
      .then(({data}) => updateCheck(id, data))
      .then(() => showNotification(
        i18next.t("notification:title.success", "Success!"),
        i18next.t("notification:message.paused.check", "Check has been taken to work."),
        "success"
      ));
  };

  const deleteCheck = (id) => {
    deleteCheckRequest(id)
      .then(() => setTableItems((oldChecks) => oldChecks.filter((check) => check.id !== id)))
      .then(() => showNotification(
        i18next.t("notification:title.success", "Success!"),
        i18next.t("notification:message.deleted.check", "Check has been deleted."),
        "success"
      ));
  };

  const enableDisableCheck = (id, isEnabled) => {
    const command = isEnabled ? MANAGE_CHECK_ACTIONS.DISABLE : MANAGE_CHECK_ACTIONS.ENABLE;
    manageCheckRequest(id, command)
      .then(({data}) => updateCheck(id, data))
      .then(() => showNotification(
        i18next.t("notification:title.success", "Success!"),
        i18next.t(`notification:message.${command + "d"}.check`, `Check has been ${command + "d"}`),
        "success"
      ));
  };

  return {
    tableConfig,
    deleteCheck,
    pauseCheck,
    returnCheck,
    enableDisableCheck,
    onSelectedProjectChange,
  };
};

export default useChecksData;